import { axiosClient } from "../client";

const queryString = require("query-string");

const PAYMENT_GATEWAY_INFO_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/payment-gateway/prex-admin`;

const PAYMENT_GATEWAY_STRIP_REPORT_INFO_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/payment-gateway/stripe-report`;

const PAYMENT_GATEWAY_INFO_UPDATE = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}/payment-gateway/prex-admin`;

const LOCATION_INFO_GET = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_EATPRESTO}/location/${locationId}`;

export const fetchLocationInfo = (locationId) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl({
      url: LOCATION_INFO_GET(locationId),
    }),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const fetchPaymentGatewayInfo = (locationId) =>
  axiosClient({
    method: "GET",
    url: queryString.stringifyUrl({
      url: PAYMENT_GATEWAY_INFO_GET_ALL(locationId),
    }),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const fetchPaymentGatewayStripReportInfo = (locationId, filterData) => {
  return axiosClient({
    method: "GET",
    url: queryString.stringifyUrl(
      {
        url: PAYMENT_GATEWAY_STRIP_REPORT_INFO_GET_ALL(locationId),
        query: filterData,
      },
      {
        sort: false,
        arrayFormat: "comma",
        skipNull: true,
        skipEmptyString: true,
      },
    ),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });
};

export const updatePaymentGatewayInfo = (locationId, data, body, logAppName) =>
  axiosClient({
    method: "PUT",
    url: PAYMENT_GATEWAY_INFO_UPDATE(locationId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    body,
    logAppName,
    locationId,
  });
